const { ofetch } = require("ofetch");

$(function() {
    const carousel1BParams = {
        imagesLoaded:true,
        percentPosition:false,
        prevNextButtons:false,
        pageDots:false,
        cellAlign:'left'
    }
    const $carousel1BDynamic = $('.component-carousel-1b__carousel--dynamic');
    const fetchData = function() {
        $carousel1BDynamic.each(async function(index, element) {
            var $element = $(element);
            const $component = $element.closest('.component-carousel-1b');
            console.log($component);

            const action = $element.data('carousel1b-fetch');
            const response = await ofetch(action, {
                method: "GET",
            });
            //console.log(response)
            $element.height($element.outerHeight());
            $element.html(response).flickity(carousel1BParams);

            const flkty = $element.data('flickity');
            const $prevBtn = $component.find('.component-carousel-1b__nav-previous');
            const $nextBtn = $component.find('.component-carousel-1b__nav-next');
            
            // Scoped nav buttons
            $prevBtn.on('click', function () { flkty.previous(); });
            $nextBtn.on('click', function () { flkty.next(); });

            // Disable logic
            function updateNavState() {
                const index = flkty.selectedIndex;
                const lastIndex = flkty.slides.length - 1;
                $nextBtn.toggleClass('disabled', index === lastIndex);
                $prevBtn.toggleClass('disabled', index === 0);
            }

            // Run immediately after init
            updateNavState();

            flkty.on('change',updateNavState);

            window.setTimeout(function() {
                $element.height('auto');
            },1000)
        })
    }

    fetchData();

    const $carousel1BStatic = $('.component-carousel-1b__carousel--static');
    $carousel1BStatic.each(async function(index, element) {
        var $element = $(element);
        const $component = $element.closest('.component-carousel-1b');
        //console.log($component);

        $element.flickity(carousel1BParams);

        const flkty = $element.data('flickity');
        const $prevBtn = $component.find('.component-carousel-1b__nav-previous');
        const $nextBtn = $component.find('.component-carousel-1b__nav-next');
        
        // Scoped nav buttons
        $prevBtn.on('click', function () { flkty.previous(); });
        $nextBtn.on('click', function () { flkty.next(); });

        // Disable logic
        function updateNavState() {
            const index = flkty.selectedIndex;
            const lastIndex = flkty.slides.length - 1;
            $nextBtn.toggleClass('disabled', index === lastIndex);
            $prevBtn.toggleClass('disabled', index === 0);
        }

        // Run immediately after init
        updateNavState();

        flkty.on('change',updateNavState);
    });


    /*$('.component-carousel-1b__nav-previous').on( 'click', function() {
        var index = $(this).index();
        $carousel1BDynamic.flickity('previous');
        console.log(index)
    });
    $('.component-carousel-1b__nav-next').on( 'click', function() {
        var index = $(this).index();
        $carousel1BDynamic.flickity('next');
        console.log(index)
    });*/
});
